(() => {
  if (customElements.get('swaap-event')) return;
  const clamp = n => Math.max(0, Math.min(1, n));
  class SwaapEvent extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const opt = {signal:this.abort.signal};
      this.video=this.querySelector('video'); this.stage=this.querySelector('.se-stage');
      if (!this.video || !this.stage) return;
      this.intro=this.querySelector('.se-intro'); this.outro=this.querySelector('.se-outro');
      this.caption=this.querySelector('.se-caption'); this.counter=this.querySelector('[data-percent]');
      this.explorer=this.querySelector('[data-explore]');
      this.buttons=[...this.querySelectorAll('[data-chapter]')];
      this.boundaries=(this.dataset.boundaries||'0,.32,.66,1').split(',').map(Number);
      this.motion=matchMedia('(prefers-reduced-motion: reduce)'); this.mobile=matchMedia('(max-width:749px)');
      this.progress=0; this.target=0; this.raf=0; this.busy=false;
      this.onScroll=()=>{
        if (this.staticMode) return;
        const top=parseFloat(getComputedStyle(this.stage).top)||0;
        this.target=clamp((top-this.getBoundingClientRect().top)/Math.max(1,this.offsetHeight-this.stage.offsetHeight));
        this.schedule();
      };
      this.video.addEventListener('loadeddata',()=>{
        clearTimeout(this.loadTimer); this.ready=true; this.classList.add('is-ready'); this.paint(0); this.onScroll();
      },opt);
      this.video.addEventListener('seeked',()=>{
        this.busy=false; clearTimeout(this.seekTimer); this.paint(this.video.currentTime/Math.max(.001,this.video.duration-1/24)); this.schedule();
      },opt);
      this.video.addEventListener('error',()=>this.fallback('video-error'),opt);
      this.querySelector('[data-skip]')?.addEventListener('click',()=>{
        // Premier élément réellement visible après la section : on ignore les
        // voisins de hauteur nulle (noscript, blocs d'app vides).
        const firstVisible=node=>{while(node&&!node.offsetHeight)node=node.nextElementSibling;return node;};
        const root=this.closest('.shopify-section')||this.parentElement||this;
        const destination=firstVisible(this.nextElementSibling)||firstVisible(root.nextElementSibling);
        if(destination){destination.scrollIntoView({behavior:'instant',block:'start'});if(!destination.hasAttribute('tabindex'))destination.setAttribute('tabindex','-1');destination.focus({preventScroll:true});}
      },opt);
      this.buttons.forEach((button,i)=>button.addEventListener('click',()=>{
        const fraction=Number(button.dataset.jump||[.24,.53,.99][i]);
        this.jumpTo(fraction);
      },opt));
      this.explorer?.addEventListener('pointerdown',()=>{this.scrubbing=true;},opt);
      window.addEventListener('pointerup',()=>{this.scrubbing=false;},opt);
      window.addEventListener('pointercancel',()=>{this.scrubbing=false;},opt);
      this.explorer?.addEventListener('input',()=>{
        const p=Number(this.explorer.value)/1000;
        this.progress=p;this.jumpTo(p);
      },opt);
      window.addEventListener('scroll',this.onScroll,{...opt,passive:true});
      window.addEventListener('resize',this.onScroll,{...opt,passive:true});
      this.motion.addEventListener('change',()=>this.configure(),opt);
      this.mobile.addEventListener('change',()=>this.configure(),opt);
      this.observer=new ResizeObserver(this.onScroll);this.observer.observe(this);
      this.configure();
    }
    jumpTo(fraction){
      const top=parseFloat(getComputedStyle(this.stage).top)||0;
      window.scrollTo({top:scrollY+this.getBoundingClientRect().top-top+clamp(fraction)*(this.offsetHeight-this.stage.offsetHeight),behavior:'instant'});
      this.onScroll();
    }
    configure(){
      // L'affiche suit le format : verticale sous 750 px, horizontale au-dessus.
      this.desktopPoster ??= this.video.poster;
      this.video.poster = this.mobile.matches && this.dataset.mobilePoster ? this.dataset.mobilePoster : this.desktopPoster;
      if(this.motion.matches||navigator.connection?.saveData)return this.fallback('preference');
      const src=this.mobile.matches&&this.dataset.mobileSrc?this.dataset.mobileSrc:this.dataset.src;
      if(!src)return this.fallback('missing-source');
      this.staticMode=false;this.classList.remove('is-static');this.classList.add('is-enhanced');
      if(this.video.getAttribute('src')!==src){
        this.ready=false;this.busy=false;this.classList.remove('is-ready');
        this.video.src=src;this.video.muted=true;this.video.load();
        clearTimeout(this.loadTimer);this.loadTimer=setTimeout(()=>{if(!this.ready)this.fallback('loading-timeout');},20000);
      }
      this.onScroll();
    }
    fallback(reason){
      this.staticMode=true;this.ready=false;this.dataset.fallback=reason;
      this.classList.remove('is-enhanced','is-ready');this.classList.add('is-static');
      clearTimeout(this.loadTimer);clearTimeout(this.seekTimer);cancelAnimationFrame(this.raf);this.raf=0;
      this.video.pause();this.video.removeAttribute('src');this.video.load();
      this.paint(1);
    }
    schedule(){if(!this.raf&&!this.staticMode)this.raf=requestAnimationFrame(()=>this.tick());}
    tick(){
      this.raf=0;if(this.staticMode)return;
      const delta=this.target-this.progress;
      this.progress=Math.abs(delta)<.0008?this.target:this.progress+delta*.25;
      if(this.ready&&Number.isFinite(this.video.duration)){
        const end=Math.max(0,this.video.duration-1/24);
        const time=Math.min(end,Math.round(this.progress*end*24)/24);
        if(!this.busy&&Math.abs(this.video.currentTime-time)>1/48){
          this.busy=true;this.video.currentTime=time;
          this.seekTimer=setTimeout(()=>{this.busy=false;this.schedule();},1200);
        }
      }else this.paint(0);
      if(Math.abs(this.target-this.progress)>.0001)this.schedule();
    }
    paint(value){
      const p=clamp(value);this.dataset.progress=p.toFixed(4);this.dataset.displayTime=this.video.currentTime.toFixed(3);
      const intro=clamp(1-p/.13),outro=clamp((p-.925)/.05);
      if(this.intro){this.intro.style.opacity=intro;this.intro.inert=intro<.1;this.intro.setAttribute('aria-hidden',String(intro<.1));}
      if(this.outro){this.outro.style.opacity=outro;this.outro.inert=outro<.95;this.outro.setAttribute('aria-hidden',String(outro<.95));this.outro.style.pointerEvents=outro>.95?'auto':'none';this.outro.querySelectorAll('a').forEach(a=>a.tabIndex=outro>.95?0:-1);}
      const index=p<this.boundaries[1]?0:p<this.boundaries[2]?1:2;
      this.buttons.forEach((button,i)=>{
        button.style.setProperty('--step-progress',clamp((p-this.boundaries[i])/(this.boundaries[i+1]-this.boundaries[i])));
        if(i===index)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');
      });
      if(this.caption){this.caption.textContent=p>.57&&p<this.boundaries[2]?(this.dataset.travelLabel||'Le lieu se transforme…'):this.buttons[index]?.textContent.replace(/^\s*\d{2}\s*/, '').trim();this.caption.style.opacity=p>.13&&p<.90?'1':'0';}
      if(this.counter)this.counter.textContent=String(Math.round(p*100)).padStart(2,'0')+' %';
      if(this.explorer){
        if(!this.scrubbing)this.explorer.value=String(Math.round(p*1000));
        this.explorer.setAttribute('aria-valuetext',Math.round(p*100)+' % — '+(this.buttons[index]?.textContent.replace(/^\s*\d{2}\s*/, '').trim()||''));
      }
    }
    disconnectedCallback(){
      this.abort?.abort();this.abort=null;this.observer?.disconnect();clearTimeout(this.loadTimer);clearTimeout(this.seekTimer);cancelAnimationFrame(this.raf);this.raf=0;this.video?.pause();
    }
  }
  customElements.define('swaap-event',SwaapEvent);
})();
